import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';
import { NegotiableIcon } from './NegotiableIcon';
import styles from './SbRespNegotiable.scss';

const SbRespNegotiableComponent = ({ item }) => {
    // If item is not negotiable, it doesn't have a badge.
    if (!get(item, 'displayInfo.ctas.showMakeOffer')) {
        return null;
    }

    return (
        <div className={styles.container}>
            <a href={item.pdpURL} className={styles.link}>
                <NegotiableIcon className={styles.icon} />
                <FormattedMessage
                    id="sb.SbRespNegotiable.negotiableLabel"
                    defaultMessage="Negotiable"
                />
            </a>
        </div>
    );
};

SbRespNegotiableComponent.propTypes = {
    item: PropTypes.object.isRequired,
};

export const SbRespNegotiable = createFragmentContainer(SbRespNegotiableComponent, {
    item: graphql`
        fragment SbRespNegotiable_item on Item {
            pdpURL
            displayInfo(page: searchAndBrowse, isTrade: $isTrade) {
                ctas {
                    showMakeOffer
                }
            }
        }
    `,
});
